import { render, staticRenderFns } from "./nomore.vue?vue&type=template&id=7ae8e3e6&scoped=true"
import script from "./nomore.vue?vue&type=script&lang=js"
export * from "./nomore.vue?vue&type=script&lang=js"
import style0 from "./nomore.vue?vue&type=style&index=0&id=7ae8e3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae8e3e6",
  null
  
)

export default component.exports